import { render } from "./NotaFiscalServicoImpostos.vue?vue&type=template&id=9e0fbb9e&scoped=true&ts=true"
import script from "./NotaFiscalServicoImpostos.vue?vue&type=script&lang=ts"
export * from "./NotaFiscalServicoImpostos.vue?vue&type=script&lang=ts"

import "./NotaFiscalServicoImpostos.vue?vue&type=style&index=0&id=9e0fbb9e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e0fbb9e"]])

export default __exports__